<template>
  <div class="content">
    <div class="md-layout">

    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyProfile"
};
</script>

<style scoped>

</style>
